import {selectorFamily} from 'recoil';
import {getUserPhoto} from '../../../../api/strategies/searchWorkersStrategy';

export const managerListItemSelector = selectorFamily<string | null, number>({
  key: 'managerListItemSelector',
  get: (id) => () => getUserPhoto(id),
});
